const class_data = [
    [
        {
            id: "1",
            class_name: "العامود Pole ",
            class_image: "/assets/pole2.png",
            alt_image: "/assets/class6.jpg",
            details: {
                class_description: "رقص العامود هو فن يمزج بين الرقص والجمباز, ويعتبر احسن وسيلة انك تمرني كل عضلة بجسمك! مو بس حيقوي وينسق جسمك بالكامل هو راح يطور قدرة قلبك وأوعيتك الدموية، و راح يزيد من مرونتك ويبسطك",
            },
        },
    ],
    [

        {
            id: "2",
            class_name: "زومبا Zumba",
            class_image: "/assets/zumba2.png",
            alt_image: "/assets/class5.jpg",
            details: {
                class_description: "الزومبا هو نوع من الرقص اللي بيخلط بين الرياضة والحركات السريعة مع الإيقاعات المختلفة. البرنامج بيتضمن تمارين لتقوية العضلات وتحسين المرونة، وكمان بيساعد على تحسين صحة القلب والرئتين",
            },
        },
    ],

    [
        {
            id: "3",
            class_name: "يوقا Yoga",
            class_image: "/assets/yoga2.png",
            alt_image: "/assets/class9.jpg",
            details: {
                class_description: "حسّني من تناسق جسدك، توازنك، وهيئة جسمك مع حصة اليوقا اللي تجمع بين أنماط مختلفة من تقنيات التنفس والتأمل.  في هذا الكلاس رح نجمع بين أوضاع اليوقا وتمارين التنفس عشان تقوي جسمك وتقللي توترك وتهدئي عقلك",
            },
        },],
    [
        {
            id: "4",
            class_name: "رقص شرقي BellyDance",
            class_image: "/assets/belly2.png",
            alt_image: "/assets/class2.jpg",
            details: {
                class_description: "الرقص الشرقي هو فن راقٍ يجمع بين الحركات الإيقاعية والإيماءات الجسدية الرشيقة، إذا كنتي تدوري على تجربة مميزة وممتعة للتعبير عن نفسك والترويح عن روحك فالرقص الشرقي هو اقتراحنا لكي. ",
            },
        },],
]
export default class_data
